'use client';

import React from 'react';

interface SmartFontProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * 智能文本字体 - 根据页面语言自动应用不同字体
 * :lang(zh) 为中文应用中文衬线字体，英文使用英文优雅字体
 */
export const SmartText: React.FC<SmartFontProps> = ({ 
  children, 
  className = '' 
}) => {
  return (
    <span className={`content-font ${className}`}>
      {children}
    </span>
  );
};

/**
 * 智能标题字体 - 根据页面语言自动应用不同字体
 * :lang(zh) 为中文使用毛笔字体，英文使用花体
 */
export const SmartTitle: React.FC<SmartFontProps> = ({ 
  children, 
  className = '' 
}) => {
  return (
    <span className={`title-font ${className}`}>
      {children}
    </span>
  );
};

/**
 * 智能手写字体 - 根据页面语言自动应用不同字体
 * :lang(zh) 为中文使用中文手写体，英文使用英文手写体
 */
export const SmartHandwriting: React.FC<SmartFontProps> = ({ 
  children, 
  className = '' 
}) => {
  return (
    <span className={`handwriting-font ${className}`}>
      {children}
    </span>
  );
};

/**
 * 智能装饰字体 - 根据页面语言自动应用不同字体
 * :lang(zh) 为中文使用中文毛笔字体，英文使用英文艺术字体
 */
export const SmartFancy: React.FC<SmartFontProps> = ({ 
  children, 
  className = '' 
}) => {
  return (
    <span className={`fancy-font ${className}`}>
      {children}
    </span>
  );
}; 